// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pYgWu","footerText":"styles_footerText__9g7fJ"};